/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as Clear_cacheRouteImport } from './routes/clear_cache'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as Sign_inRouteImport } from './routes/sign_in'
import { Route as Sign_outRouteImport } from './routes/sign_out'
import { Route as Sign_upRouteImport } from './routes/sign_up'
import { Route as CallbackIntegrationRouteImport } from './routes/callback/integration'
import { Route as AuthProviderCallbackRouteImport } from './routes/auth/$provider/callback'
import { Route as OOrganizationIdIndexRouteImport } from './routes/o/$organizationId/index'
import { Route as OOrganizationIdSign_inRouteImport } from './routes/o/$organizationId/sign_in'
import { Route as OOrganizationIdViewsRouteImport } from './routes/o/$organizationId/views'
import { Route as OOrganizationIdV2IndexRouteImport } from './routes/o/$organizationId/v2/index'
import { Route as OOrganizationIdV2SettingsIndexRouteImport } from './routes/o/$organizationId/v2/settings/index'
import { Route as OOrganizationIdV2SettingsBusiness_dayRouteImport } from './routes/o/$organizationId/v2/settings/business_day'
import { Route as OOrganizationIdV2SettingsDimension_groupsRouteImport } from './routes/o/$organizationId/v2/settings/dimension_groups'
import { Route as OOrganizationIdV2SettingsGoal_dimensionsRouteImport } from './routes/o/$organizationId/v2/settings/goal_dimensions'
import { Route as OOrganizationIdV2SettingsInvitationsRouteImport } from './routes/o/$organizationId/v2/settings/invitations'
import { Route as OOrganizationIdV2SettingsMeRouteImport } from './routes/o/$organizationId/v2/settings/me'
import { Route as OOrganizationIdV2SettingsPoliciesRouteImport } from './routes/o/$organizationId/v2/settings/policies'
import { Route as OOrganizationIdV2SettingsRecord_visibilitiesRouteImport } from './routes/o/$organizationId/v2/settings/record_visibilities'
import { Route as OOrganizationIdV2SettingsUser_activitiesRouteImport } from './routes/o/$organizationId/v2/settings/user_activities'
import { Route as OOrganizationIdV2SettingsUsersRouteImport } from './routes/o/$organizationId/v2/settings/users'
import { Route as OOrganizationIdV2SettingsElt_modelsIndexRouteImport } from './routes/o/$organizationId/v2/settings/elt_models/index'
import { Route as OOrganizationIdV2SettingsGoal_configsIndexRouteImport } from './routes/o/$organizationId/v2/settings/goal_configs/index'
import { Route as OOrganizationIdV2SettingsSourcesIndexRouteImport } from './routes/o/$organizationId/v2/settings/sources/index'
import { Route as OOrganizationIdV2SettingsUser_groupsIndexRouteImport } from './routes/o/$organizationId/v2/settings/user_groups/index'
import { Route as OOrganizationIdV2SettingsUser_groupsCsvRouteImport } from './routes/o/$organizationId/v2/settings/user_groups/csv'
import { Route as OOrganizationIdV2SettingsElt_modelsModelNameFormRouteImport } from './routes/o/$organizationId/v2/settings/elt_models/$modelName/form'
import { Route as OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRouteImport } from './routes/o/$organizationId/v2/settings/goal_configs/$goalConfigId/index'
import { Route as OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRouteImport } from './routes/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv'
import { Route as OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRouteImport } from './routes/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit'
import { Route as OOrganizationIdV2SettingsSourcesSourceIdConnectionRouteImport } from './routes/o/$organizationId/v2/settings/sources/$sourceId/connection'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const Clear_cacheRoute = Clear_cacheRouteImport.update({
  id: '/clear_cache',
  path: '/clear_cache',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_inRoute = Sign_inRouteImport.update({
  id: '/sign_in',
  path: '/sign_in',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_outRoute = Sign_outRouteImport.update({
  id: '/sign_out',
  path: '/sign_out',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_upRoute = Sign_upRouteImport.update({
  id: '/sign_up',
  path: '/sign_up',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackIntegrationRoute = CallbackIntegrationRouteImport.update({
  id: '/callback/integration',
  path: '/callback/integration',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthProviderCallbackRoute = AuthProviderCallbackRouteImport.update({
  id: '/auth/$provider/callback',
  path: '/auth/$provider/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrganizationIdIndexRoute = OOrganizationIdIndexRouteImport.update({
  id: '/o/$organizationId/',
  path: '/o/$organizationId/',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrganizationIdSign_inRoute = OOrganizationIdSign_inRouteImport.update({
  id: '/o/$organizationId/sign_in',
  path: '/o/$organizationId/sign_in',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrganizationIdViewsRoute = OOrganizationIdViewsRouteImport.update({
  id: '/o/$organizationId/views',
  path: '/o/$organizationId/views',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrganizationIdV2IndexRoute = OOrganizationIdV2IndexRouteImport.update({
  id: '/o/$organizationId/v2/',
  path: '/o/$organizationId/v2/',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrganizationIdV2SettingsIndexRoute =
  OOrganizationIdV2SettingsIndexRouteImport.update({
    id: '/o/$organizationId/v2/settings/',
    path: '/o/$organizationId/v2/settings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsBusiness_dayRoute =
  OOrganizationIdV2SettingsBusiness_dayRouteImport.update({
    id: '/o/$organizationId/v2/settings/business_day',
    path: '/o/$organizationId/v2/settings/business_day',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsDimension_groupsRoute =
  OOrganizationIdV2SettingsDimension_groupsRouteImport.update({
    id: '/o/$organizationId/v2/settings/dimension_groups',
    path: '/o/$organizationId/v2/settings/dimension_groups',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsGoal_dimensionsRoute =
  OOrganizationIdV2SettingsGoal_dimensionsRouteImport.update({
    id: '/o/$organizationId/v2/settings/goal_dimensions',
    path: '/o/$organizationId/v2/settings/goal_dimensions',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsInvitationsRoute =
  OOrganizationIdV2SettingsInvitationsRouteImport.update({
    id: '/o/$organizationId/v2/settings/invitations',
    path: '/o/$organizationId/v2/settings/invitations',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsMeRoute =
  OOrganizationIdV2SettingsMeRouteImport.update({
    id: '/o/$organizationId/v2/settings/me',
    path: '/o/$organizationId/v2/settings/me',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsPoliciesRoute =
  OOrganizationIdV2SettingsPoliciesRouteImport.update({
    id: '/o/$organizationId/v2/settings/policies',
    path: '/o/$organizationId/v2/settings/policies',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsRecord_visibilitiesRoute =
  OOrganizationIdV2SettingsRecord_visibilitiesRouteImport.update({
    id: '/o/$organizationId/v2/settings/record_visibilities',
    path: '/o/$organizationId/v2/settings/record_visibilities',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsUser_activitiesRoute =
  OOrganizationIdV2SettingsUser_activitiesRouteImport.update({
    id: '/o/$organizationId/v2/settings/user_activities',
    path: '/o/$organizationId/v2/settings/user_activities',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsUsersRoute =
  OOrganizationIdV2SettingsUsersRouteImport.update({
    id: '/o/$organizationId/v2/settings/users',
    path: '/o/$organizationId/v2/settings/users',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsElt_modelsIndexRoute =
  OOrganizationIdV2SettingsElt_modelsIndexRouteImport.update({
    id: '/o/$organizationId/v2/settings/elt_models/',
    path: '/o/$organizationId/v2/settings/elt_models/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsGoal_configsIndexRoute =
  OOrganizationIdV2SettingsGoal_configsIndexRouteImport.update({
    id: '/o/$organizationId/v2/settings/goal_configs/',
    path: '/o/$organizationId/v2/settings/goal_configs/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsSourcesIndexRoute =
  OOrganizationIdV2SettingsSourcesIndexRouteImport.update({
    id: '/o/$organizationId/v2/settings/sources/',
    path: '/o/$organizationId/v2/settings/sources/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsUser_groupsIndexRoute =
  OOrganizationIdV2SettingsUser_groupsIndexRouteImport.update({
    id: '/o/$organizationId/v2/settings/user_groups/',
    path: '/o/$organizationId/v2/settings/user_groups/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsUser_groupsCsvRoute =
  OOrganizationIdV2SettingsUser_groupsCsvRouteImport.update({
    id: '/o/$organizationId/v2/settings/user_groups/csv',
    path: '/o/$organizationId/v2/settings/user_groups/csv',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsElt_modelsModelNameFormRoute =
  OOrganizationIdV2SettingsElt_modelsModelNameFormRouteImport.update({
    id: '/o/$organizationId/v2/settings/elt_models/$modelName/form',
    path: '/o/$organizationId/v2/settings/elt_models/$modelName/form',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRoute =
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRouteImport.update({
    id: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/',
    path: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRoute =
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRouteImport.update({
    id: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv',
    path: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRoute =
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRouteImport.update({
    id: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit',
    path: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const OOrganizationIdV2SettingsSourcesSourceIdConnectionRoute =
  OOrganizationIdV2SettingsSourcesSourceIdConnectionRouteImport.update({
    id: '/o/$organizationId/v2/settings/sources/$sourceId/connection',
    path: '/o/$organizationId/v2/settings/sources/$sourceId/connection',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/clear_cache': typeof Clear_cacheRoute
  '/error': typeof ErrorRoute
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/sign_up': typeof Sign_upRoute
  '/callback/integration': typeof CallbackIntegrationRoute
  '/auth/$provider/callback': typeof AuthProviderCallbackRoute
  '/o/$organizationId/sign_in': typeof OOrganizationIdSign_inRoute
  '/o/$organizationId/views': typeof OOrganizationIdViewsRoute
  '/o/$organizationId/': typeof OOrganizationIdIndexRoute
  '/o/$organizationId/v2/': typeof OOrganizationIdV2IndexRoute
  '/o/$organizationId/v2/settings/business_day': typeof OOrganizationIdV2SettingsBusiness_dayRoute
  '/o/$organizationId/v2/settings/dimension_groups': typeof OOrganizationIdV2SettingsDimension_groupsRoute
  '/o/$organizationId/v2/settings/goal_dimensions': typeof OOrganizationIdV2SettingsGoal_dimensionsRoute
  '/o/$organizationId/v2/settings/invitations': typeof OOrganizationIdV2SettingsInvitationsRoute
  '/o/$organizationId/v2/settings/me': typeof OOrganizationIdV2SettingsMeRoute
  '/o/$organizationId/v2/settings/policies': typeof OOrganizationIdV2SettingsPoliciesRoute
  '/o/$organizationId/v2/settings/record_visibilities': typeof OOrganizationIdV2SettingsRecord_visibilitiesRoute
  '/o/$organizationId/v2/settings/user_activities': typeof OOrganizationIdV2SettingsUser_activitiesRoute
  '/o/$organizationId/v2/settings/users': typeof OOrganizationIdV2SettingsUsersRoute
  '/o/$organizationId/v2/settings/': typeof OOrganizationIdV2SettingsIndexRoute
  '/o/$organizationId/v2/settings/user_groups/csv': typeof OOrganizationIdV2SettingsUser_groupsCsvRoute
  '/o/$organizationId/v2/settings/elt_models/': typeof OOrganizationIdV2SettingsElt_modelsIndexRoute
  '/o/$organizationId/v2/settings/goal_configs/': typeof OOrganizationIdV2SettingsGoal_configsIndexRoute
  '/o/$organizationId/v2/settings/sources/': typeof OOrganizationIdV2SettingsSourcesIndexRoute
  '/o/$organizationId/v2/settings/user_groups/': typeof OOrganizationIdV2SettingsUser_groupsIndexRoute
  '/o/$organizationId/v2/settings/elt_models/$modelName/form': typeof OOrganizationIdV2SettingsElt_modelsModelNameFormRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRoute
  '/o/$organizationId/v2/settings/sources/$sourceId/connection': typeof OOrganizationIdV2SettingsSourcesSourceIdConnectionRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/clear_cache': typeof Clear_cacheRoute
  '/error': typeof ErrorRoute
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/sign_up': typeof Sign_upRoute
  '/callback/integration': typeof CallbackIntegrationRoute
  '/auth/$provider/callback': typeof AuthProviderCallbackRoute
  '/o/$organizationId/sign_in': typeof OOrganizationIdSign_inRoute
  '/o/$organizationId/views': typeof OOrganizationIdViewsRoute
  '/o/$organizationId': typeof OOrganizationIdIndexRoute
  '/o/$organizationId/v2': typeof OOrganizationIdV2IndexRoute
  '/o/$organizationId/v2/settings/business_day': typeof OOrganizationIdV2SettingsBusiness_dayRoute
  '/o/$organizationId/v2/settings/dimension_groups': typeof OOrganizationIdV2SettingsDimension_groupsRoute
  '/o/$organizationId/v2/settings/goal_dimensions': typeof OOrganizationIdV2SettingsGoal_dimensionsRoute
  '/o/$organizationId/v2/settings/invitations': typeof OOrganizationIdV2SettingsInvitationsRoute
  '/o/$organizationId/v2/settings/me': typeof OOrganizationIdV2SettingsMeRoute
  '/o/$organizationId/v2/settings/policies': typeof OOrganizationIdV2SettingsPoliciesRoute
  '/o/$organizationId/v2/settings/record_visibilities': typeof OOrganizationIdV2SettingsRecord_visibilitiesRoute
  '/o/$organizationId/v2/settings/user_activities': typeof OOrganizationIdV2SettingsUser_activitiesRoute
  '/o/$organizationId/v2/settings/users': typeof OOrganizationIdV2SettingsUsersRoute
  '/o/$organizationId/v2/settings': typeof OOrganizationIdV2SettingsIndexRoute
  '/o/$organizationId/v2/settings/user_groups/csv': typeof OOrganizationIdV2SettingsUser_groupsCsvRoute
  '/o/$organizationId/v2/settings/elt_models': typeof OOrganizationIdV2SettingsElt_modelsIndexRoute
  '/o/$organizationId/v2/settings/goal_configs': typeof OOrganizationIdV2SettingsGoal_configsIndexRoute
  '/o/$organizationId/v2/settings/sources': typeof OOrganizationIdV2SettingsSourcesIndexRoute
  '/o/$organizationId/v2/settings/user_groups': typeof OOrganizationIdV2SettingsUser_groupsIndexRoute
  '/o/$organizationId/v2/settings/elt_models/$modelName/form': typeof OOrganizationIdV2SettingsElt_modelsModelNameFormRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRoute
  '/o/$organizationId/v2/settings/sources/$sourceId/connection': typeof OOrganizationIdV2SettingsSourcesSourceIdConnectionRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/clear_cache': typeof Clear_cacheRoute
  '/error': typeof ErrorRoute
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/sign_up': typeof Sign_upRoute
  '/callback/integration': typeof CallbackIntegrationRoute
  '/auth/$provider/callback': typeof AuthProviderCallbackRoute
  '/o/$organizationId/sign_in': typeof OOrganizationIdSign_inRoute
  '/o/$organizationId/views': typeof OOrganizationIdViewsRoute
  '/o/$organizationId/': typeof OOrganizationIdIndexRoute
  '/o/$organizationId/v2/': typeof OOrganizationIdV2IndexRoute
  '/o/$organizationId/v2/settings/business_day': typeof OOrganizationIdV2SettingsBusiness_dayRoute
  '/o/$organizationId/v2/settings/dimension_groups': typeof OOrganizationIdV2SettingsDimension_groupsRoute
  '/o/$organizationId/v2/settings/goal_dimensions': typeof OOrganizationIdV2SettingsGoal_dimensionsRoute
  '/o/$organizationId/v2/settings/invitations': typeof OOrganizationIdV2SettingsInvitationsRoute
  '/o/$organizationId/v2/settings/me': typeof OOrganizationIdV2SettingsMeRoute
  '/o/$organizationId/v2/settings/policies': typeof OOrganizationIdV2SettingsPoliciesRoute
  '/o/$organizationId/v2/settings/record_visibilities': typeof OOrganizationIdV2SettingsRecord_visibilitiesRoute
  '/o/$organizationId/v2/settings/user_activities': typeof OOrganizationIdV2SettingsUser_activitiesRoute
  '/o/$organizationId/v2/settings/users': typeof OOrganizationIdV2SettingsUsersRoute
  '/o/$organizationId/v2/settings/': typeof OOrganizationIdV2SettingsIndexRoute
  '/o/$organizationId/v2/settings/user_groups/csv': typeof OOrganizationIdV2SettingsUser_groupsCsvRoute
  '/o/$organizationId/v2/settings/elt_models/': typeof OOrganizationIdV2SettingsElt_modelsIndexRoute
  '/o/$organizationId/v2/settings/goal_configs/': typeof OOrganizationIdV2SettingsGoal_configsIndexRoute
  '/o/$organizationId/v2/settings/sources/': typeof OOrganizationIdV2SettingsSourcesIndexRoute
  '/o/$organizationId/v2/settings/user_groups/': typeof OOrganizationIdV2SettingsUser_groupsIndexRoute
  '/o/$organizationId/v2/settings/elt_models/$modelName/form': typeof OOrganizationIdV2SettingsElt_modelsModelNameFormRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRoute
  '/o/$organizationId/v2/settings/sources/$sourceId/connection': typeof OOrganizationIdV2SettingsSourcesSourceIdConnectionRoute
  '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/': typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clear_cache'
    | '/error'
    | '/sign_in'
    | '/sign_out'
    | '/sign_up'
    | '/callback/integration'
    | '/auth/$provider/callback'
    | '/o/$organizationId/sign_in'
    | '/o/$organizationId/views'
    | '/o/$organizationId/'
    | '/o/$organizationId/v2/'
    | '/o/$organizationId/v2/settings/business_day'
    | '/o/$organizationId/v2/settings/dimension_groups'
    | '/o/$organizationId/v2/settings/goal_dimensions'
    | '/o/$organizationId/v2/settings/invitations'
    | '/o/$organizationId/v2/settings/me'
    | '/o/$organizationId/v2/settings/policies'
    | '/o/$organizationId/v2/settings/record_visibilities'
    | '/o/$organizationId/v2/settings/user_activities'
    | '/o/$organizationId/v2/settings/users'
    | '/o/$organizationId/v2/settings/'
    | '/o/$organizationId/v2/settings/user_groups/csv'
    | '/o/$organizationId/v2/settings/elt_models/'
    | '/o/$organizationId/v2/settings/goal_configs/'
    | '/o/$organizationId/v2/settings/sources/'
    | '/o/$organizationId/v2/settings/user_groups/'
    | '/o/$organizationId/v2/settings/elt_models/$modelName/form'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit'
    | '/o/$organizationId/v2/settings/sources/$sourceId/connection'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/clear_cache'
    | '/error'
    | '/sign_in'
    | '/sign_out'
    | '/sign_up'
    | '/callback/integration'
    | '/auth/$provider/callback'
    | '/o/$organizationId/sign_in'
    | '/o/$organizationId/views'
    | '/o/$organizationId'
    | '/o/$organizationId/v2'
    | '/o/$organizationId/v2/settings/business_day'
    | '/o/$organizationId/v2/settings/dimension_groups'
    | '/o/$organizationId/v2/settings/goal_dimensions'
    | '/o/$organizationId/v2/settings/invitations'
    | '/o/$organizationId/v2/settings/me'
    | '/o/$organizationId/v2/settings/policies'
    | '/o/$organizationId/v2/settings/record_visibilities'
    | '/o/$organizationId/v2/settings/user_activities'
    | '/o/$organizationId/v2/settings/users'
    | '/o/$organizationId/v2/settings'
    | '/o/$organizationId/v2/settings/user_groups/csv'
    | '/o/$organizationId/v2/settings/elt_models'
    | '/o/$organizationId/v2/settings/goal_configs'
    | '/o/$organizationId/v2/settings/sources'
    | '/o/$organizationId/v2/settings/user_groups'
    | '/o/$organizationId/v2/settings/elt_models/$modelName/form'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit'
    | '/o/$organizationId/v2/settings/sources/$sourceId/connection'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId'
  id:
    | '__root__'
    | '/'
    | '/clear_cache'
    | '/error'
    | '/sign_in'
    | '/sign_out'
    | '/sign_up'
    | '/callback/integration'
    | '/auth/$provider/callback'
    | '/o/$organizationId/sign_in'
    | '/o/$organizationId/views'
    | '/o/$organizationId/'
    | '/o/$organizationId/v2/'
    | '/o/$organizationId/v2/settings/business_day'
    | '/o/$organizationId/v2/settings/dimension_groups'
    | '/o/$organizationId/v2/settings/goal_dimensions'
    | '/o/$organizationId/v2/settings/invitations'
    | '/o/$organizationId/v2/settings/me'
    | '/o/$organizationId/v2/settings/policies'
    | '/o/$organizationId/v2/settings/record_visibilities'
    | '/o/$organizationId/v2/settings/user_activities'
    | '/o/$organizationId/v2/settings/users'
    | '/o/$organizationId/v2/settings/'
    | '/o/$organizationId/v2/settings/user_groups/csv'
    | '/o/$organizationId/v2/settings/elt_models/'
    | '/o/$organizationId/v2/settings/goal_configs/'
    | '/o/$organizationId/v2/settings/sources/'
    | '/o/$organizationId/v2/settings/user_groups/'
    | '/o/$organizationId/v2/settings/elt_models/$modelName/form'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit'
    | '/o/$organizationId/v2/settings/sources/$sourceId/connection'
    | '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  Clear_cacheRoute: typeof Clear_cacheRoute
  ErrorRoute: typeof ErrorRoute
  Sign_inRoute: typeof Sign_inRoute
  Sign_outRoute: typeof Sign_outRoute
  Sign_upRoute: typeof Sign_upRoute
  CallbackIntegrationRoute: typeof CallbackIntegrationRoute
  AuthProviderCallbackRoute: typeof AuthProviderCallbackRoute
  OOrganizationIdSign_inRoute: typeof OOrganizationIdSign_inRoute
  OOrganizationIdViewsRoute: typeof OOrganizationIdViewsRoute
  OOrganizationIdIndexRoute: typeof OOrganizationIdIndexRoute
  OOrganizationIdV2IndexRoute: typeof OOrganizationIdV2IndexRoute
  OOrganizationIdV2SettingsBusiness_dayRoute: typeof OOrganizationIdV2SettingsBusiness_dayRoute
  OOrganizationIdV2SettingsDimension_groupsRoute: typeof OOrganizationIdV2SettingsDimension_groupsRoute
  OOrganizationIdV2SettingsGoal_dimensionsRoute: typeof OOrganizationIdV2SettingsGoal_dimensionsRoute
  OOrganizationIdV2SettingsInvitationsRoute: typeof OOrganizationIdV2SettingsInvitationsRoute
  OOrganizationIdV2SettingsMeRoute: typeof OOrganizationIdV2SettingsMeRoute
  OOrganizationIdV2SettingsPoliciesRoute: typeof OOrganizationIdV2SettingsPoliciesRoute
  OOrganizationIdV2SettingsRecord_visibilitiesRoute: typeof OOrganizationIdV2SettingsRecord_visibilitiesRoute
  OOrganizationIdV2SettingsUser_activitiesRoute: typeof OOrganizationIdV2SettingsUser_activitiesRoute
  OOrganizationIdV2SettingsUsersRoute: typeof OOrganizationIdV2SettingsUsersRoute
  OOrganizationIdV2SettingsIndexRoute: typeof OOrganizationIdV2SettingsIndexRoute
  OOrganizationIdV2SettingsUser_groupsCsvRoute: typeof OOrganizationIdV2SettingsUser_groupsCsvRoute
  OOrganizationIdV2SettingsElt_modelsIndexRoute: typeof OOrganizationIdV2SettingsElt_modelsIndexRoute
  OOrganizationIdV2SettingsGoal_configsIndexRoute: typeof OOrganizationIdV2SettingsGoal_configsIndexRoute
  OOrganizationIdV2SettingsSourcesIndexRoute: typeof OOrganizationIdV2SettingsSourcesIndexRoute
  OOrganizationIdV2SettingsUser_groupsIndexRoute: typeof OOrganizationIdV2SettingsUser_groupsIndexRoute
  OOrganizationIdV2SettingsElt_modelsModelNameFormRoute: typeof OOrganizationIdV2SettingsElt_modelsModelNameFormRoute
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRoute: typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRoute
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRoute: typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRoute
  OOrganizationIdV2SettingsSourcesSourceIdConnectionRoute: typeof OOrganizationIdV2SettingsSourcesSourceIdConnectionRoute
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRoute: typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clear_cache': {
      id: '/clear_cache'
      path: '/clear_cache'
      fullPath: '/clear_cache'
      preLoaderRoute: typeof Clear_cacheRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_in': {
      id: '/sign_in'
      path: '/sign_in'
      fullPath: '/sign_in'
      preLoaderRoute: typeof Sign_inRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_out': {
      id: '/sign_out'
      path: '/sign_out'
      fullPath: '/sign_out'
      preLoaderRoute: typeof Sign_outRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_up': {
      id: '/sign_up'
      path: '/sign_up'
      fullPath: '/sign_up'
      preLoaderRoute: typeof Sign_upRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback/integration': {
      id: '/callback/integration'
      path: '/callback/integration'
      fullPath: '/callback/integration'
      preLoaderRoute: typeof CallbackIntegrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/$provider/callback': {
      id: '/auth/$provider/callback'
      path: '/auth/$provider/callback'
      fullPath: '/auth/$provider/callback'
      preLoaderRoute: typeof AuthProviderCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/': {
      id: '/o/$organizationId/'
      path: '/o/$organizationId'
      fullPath: '/o/$organizationId/'
      preLoaderRoute: typeof OOrganizationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/sign_in': {
      id: '/o/$organizationId/sign_in'
      path: '/o/$organizationId/sign_in'
      fullPath: '/o/$organizationId/sign_in'
      preLoaderRoute: typeof OOrganizationIdSign_inRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/views': {
      id: '/o/$organizationId/views'
      path: '/o/$organizationId/views'
      fullPath: '/o/$organizationId/views'
      preLoaderRoute: typeof OOrganizationIdViewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/': {
      id: '/o/$organizationId/v2/'
      path: '/o/$organizationId/v2'
      fullPath: '/o/$organizationId/v2/'
      preLoaderRoute: typeof OOrganizationIdV2IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/': {
      id: '/o/$organizationId/v2/settings/'
      path: '/o/$organizationId/v2/settings'
      fullPath: '/o/$organizationId/v2/settings/'
      preLoaderRoute: typeof OOrganizationIdV2SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/business_day': {
      id: '/o/$organizationId/v2/settings/business_day'
      path: '/o/$organizationId/v2/settings/business_day'
      fullPath: '/o/$organizationId/v2/settings/business_day'
      preLoaderRoute: typeof OOrganizationIdV2SettingsBusiness_dayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/dimension_groups': {
      id: '/o/$organizationId/v2/settings/dimension_groups'
      path: '/o/$organizationId/v2/settings/dimension_groups'
      fullPath: '/o/$organizationId/v2/settings/dimension_groups'
      preLoaderRoute: typeof OOrganizationIdV2SettingsDimension_groupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/goal_dimensions': {
      id: '/o/$organizationId/v2/settings/goal_dimensions'
      path: '/o/$organizationId/v2/settings/goal_dimensions'
      fullPath: '/o/$organizationId/v2/settings/goal_dimensions'
      preLoaderRoute: typeof OOrganizationIdV2SettingsGoal_dimensionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/invitations': {
      id: '/o/$organizationId/v2/settings/invitations'
      path: '/o/$organizationId/v2/settings/invitations'
      fullPath: '/o/$organizationId/v2/settings/invitations'
      preLoaderRoute: typeof OOrganizationIdV2SettingsInvitationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/me': {
      id: '/o/$organizationId/v2/settings/me'
      path: '/o/$organizationId/v2/settings/me'
      fullPath: '/o/$organizationId/v2/settings/me'
      preLoaderRoute: typeof OOrganizationIdV2SettingsMeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/policies': {
      id: '/o/$organizationId/v2/settings/policies'
      path: '/o/$organizationId/v2/settings/policies'
      fullPath: '/o/$organizationId/v2/settings/policies'
      preLoaderRoute: typeof OOrganizationIdV2SettingsPoliciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/record_visibilities': {
      id: '/o/$organizationId/v2/settings/record_visibilities'
      path: '/o/$organizationId/v2/settings/record_visibilities'
      fullPath: '/o/$organizationId/v2/settings/record_visibilities'
      preLoaderRoute: typeof OOrganizationIdV2SettingsRecord_visibilitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/user_activities': {
      id: '/o/$organizationId/v2/settings/user_activities'
      path: '/o/$organizationId/v2/settings/user_activities'
      fullPath: '/o/$organizationId/v2/settings/user_activities'
      preLoaderRoute: typeof OOrganizationIdV2SettingsUser_activitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/users': {
      id: '/o/$organizationId/v2/settings/users'
      path: '/o/$organizationId/v2/settings/users'
      fullPath: '/o/$organizationId/v2/settings/users'
      preLoaderRoute: typeof OOrganizationIdV2SettingsUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/elt_models/': {
      id: '/o/$organizationId/v2/settings/elt_models/'
      path: '/o/$organizationId/v2/settings/elt_models'
      fullPath: '/o/$organizationId/v2/settings/elt_models/'
      preLoaderRoute: typeof OOrganizationIdV2SettingsElt_modelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/goal_configs/': {
      id: '/o/$organizationId/v2/settings/goal_configs/'
      path: '/o/$organizationId/v2/settings/goal_configs'
      fullPath: '/o/$organizationId/v2/settings/goal_configs/'
      preLoaderRoute: typeof OOrganizationIdV2SettingsGoal_configsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/sources/': {
      id: '/o/$organizationId/v2/settings/sources/'
      path: '/o/$organizationId/v2/settings/sources'
      fullPath: '/o/$organizationId/v2/settings/sources/'
      preLoaderRoute: typeof OOrganizationIdV2SettingsSourcesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/user_groups/': {
      id: '/o/$organizationId/v2/settings/user_groups/'
      path: '/o/$organizationId/v2/settings/user_groups'
      fullPath: '/o/$organizationId/v2/settings/user_groups/'
      preLoaderRoute: typeof OOrganizationIdV2SettingsUser_groupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/user_groups/csv': {
      id: '/o/$organizationId/v2/settings/user_groups/csv'
      path: '/o/$organizationId/v2/settings/user_groups/csv'
      fullPath: '/o/$organizationId/v2/settings/user_groups/csv'
      preLoaderRoute: typeof OOrganizationIdV2SettingsUser_groupsCsvRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/elt_models/$modelName/form': {
      id: '/o/$organizationId/v2/settings/elt_models/$modelName/form'
      path: '/o/$organizationId/v2/settings/elt_models/$modelName/form'
      fullPath: '/o/$organizationId/v2/settings/elt_models/$modelName/form'
      preLoaderRoute: typeof OOrganizationIdV2SettingsElt_modelsModelNameFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/': {
      id: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/'
      path: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId'
      fullPath: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/'
      preLoaderRoute: typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv': {
      id: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv'
      path: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv'
      fullPath: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv'
      preLoaderRoute: typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit': {
      id: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit'
      path: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit'
      fullPath: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId/edit'
      preLoaderRoute: typeof OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$organizationId/v2/settings/sources/$sourceId/connection': {
      id: '/o/$organizationId/v2/settings/sources/$sourceId/connection'
      path: '/o/$organizationId/v2/settings/sources/$sourceId/connection'
      fullPath: '/o/$organizationId/v2/settings/sources/$sourceId/connection'
      preLoaderRoute: typeof OOrganizationIdV2SettingsSourcesSourceIdConnectionRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  Clear_cacheRoute: Clear_cacheRoute,
  ErrorRoute: ErrorRoute,
  Sign_inRoute: Sign_inRoute,
  Sign_outRoute: Sign_outRoute,
  Sign_upRoute: Sign_upRoute,
  CallbackIntegrationRoute: CallbackIntegrationRoute,
  AuthProviderCallbackRoute: AuthProviderCallbackRoute,
  OOrganizationIdSign_inRoute: OOrganizationIdSign_inRoute,
  OOrganizationIdViewsRoute: OOrganizationIdViewsRoute,
  OOrganizationIdIndexRoute: OOrganizationIdIndexRoute,
  OOrganizationIdV2IndexRoute: OOrganizationIdV2IndexRoute,
  OOrganizationIdV2SettingsBusiness_dayRoute:
    OOrganizationIdV2SettingsBusiness_dayRoute,
  OOrganizationIdV2SettingsDimension_groupsRoute:
    OOrganizationIdV2SettingsDimension_groupsRoute,
  OOrganizationIdV2SettingsGoal_dimensionsRoute:
    OOrganizationIdV2SettingsGoal_dimensionsRoute,
  OOrganizationIdV2SettingsInvitationsRoute:
    OOrganizationIdV2SettingsInvitationsRoute,
  OOrganizationIdV2SettingsMeRoute: OOrganizationIdV2SettingsMeRoute,
  OOrganizationIdV2SettingsPoliciesRoute:
    OOrganizationIdV2SettingsPoliciesRoute,
  OOrganizationIdV2SettingsRecord_visibilitiesRoute:
    OOrganizationIdV2SettingsRecord_visibilitiesRoute,
  OOrganizationIdV2SettingsUser_activitiesRoute:
    OOrganizationIdV2SettingsUser_activitiesRoute,
  OOrganizationIdV2SettingsUsersRoute: OOrganizationIdV2SettingsUsersRoute,
  OOrganizationIdV2SettingsIndexRoute: OOrganizationIdV2SettingsIndexRoute,
  OOrganizationIdV2SettingsUser_groupsCsvRoute:
    OOrganizationIdV2SettingsUser_groupsCsvRoute,
  OOrganizationIdV2SettingsElt_modelsIndexRoute:
    OOrganizationIdV2SettingsElt_modelsIndexRoute,
  OOrganizationIdV2SettingsGoal_configsIndexRoute:
    OOrganizationIdV2SettingsGoal_configsIndexRoute,
  OOrganizationIdV2SettingsSourcesIndexRoute:
    OOrganizationIdV2SettingsSourcesIndexRoute,
  OOrganizationIdV2SettingsUser_groupsIndexRoute:
    OOrganizationIdV2SettingsUser_groupsIndexRoute,
  OOrganizationIdV2SettingsElt_modelsModelNameFormRoute:
    OOrganizationIdV2SettingsElt_modelsModelNameFormRoute,
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRoute:
    OOrganizationIdV2SettingsGoal_configsGoalConfigIdCsvRoute,
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRoute:
    OOrganizationIdV2SettingsGoal_configsGoalConfigIdEditRoute,
  OOrganizationIdV2SettingsSourcesSourceIdConnectionRoute:
    OOrganizationIdV2SettingsSourcesSourceIdConnectionRoute,
  OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRoute:
    OOrganizationIdV2SettingsGoal_configsGoalConfigIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
